import React, { useState } from 'react';
import { Project, ProjectPlanStep, ProjectActivityTimeline, ProjectKnowledgeBase, ProjectFile } from '../../types';
import { useProjectStream } from './hooks/useProjectStream';
import { GenesisView } from './components/GenesisView';
import { CompilationView } from './components/CompilationView';
import { LivingDashboard } from './components/LivingDashboard';
import { InterventionModal } from './components/InterventionModal';

interface ProjectOverviewProps {
  project: Project;
  planSteps: ProjectPlanStep[];
  activities: ProjectActivityTimeline[];
  knowledge: ProjectKnowledgeBase[];
  files?: ProjectFile[];
}

const ProjectOverview: React.FC<ProjectOverviewProps> = ({ 
  project, 
  planSteps = [],
  knowledge = [],
  files = []
}) => {
  const [objective, setObjective] = useState(project.description || '');

  const {
    phase,
    setPhase,
    compilationStage,
    liveSteps,
    telemetry,
    liveKnowledge,
    liveFiles,
    intervention,
    initializeProject,
    submitIntervention
  } = useProjectStream(project.id, project, planSteps);

  // Combine initial props with live streaming state
  const combinedKnowledge = [...liveKnowledge, ...knowledge];
  const combinedFiles = [...liveFiles, ...files];

  return (
    <>
      {phase === 'genesis' && (
        <GenesisView 
          objective={objective} 
          setObjective={setObjective} 
          onStart={() => initializeProject(objective)} 
        />
      )}
      
      {phase === 'compiling' && (
        <CompilationView 
          project={project}
          objective={objective}
          compilationStage={compilationStage}
        />
      )}

      {phase === 'living' && (
        <LivingDashboard 
          project={project}
          liveSteps={liveSteps}
          telemetry={telemetry}
          liveKnowledge={combinedKnowledge}
          liveFiles={combinedFiles}
          onEditObjective={() => setPhase('genesis')}
        />
      )}

      {intervention && (
        <InterventionModal 
          intervention={intervention}
          onSubmit={submitIntervention}
        />
      )}
    </>
  );
};

export default ProjectOverview;
